import script from "./TeamVoicePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamVoicePanel.vue?vue&type=script&setup=true&lang=js"

import "./TeamVoicePanel.vue?vue&type=style&index=0&id=5af66bda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af66bda"]])

export default __exports__